module.exports = __webpack_public_path__ + "img/full2-min.fecc38de.png";